<template>
  <div id="rodape_principal" class="footer d-print-none d-flex justify-content-between align-items-center"
       style="z-index: 99999; position: fixed; width: 100%; padding: 0 15px;">
    <div>
      <strong>Copyright</strong> sgo.fpinheiro.com &copy; {{ this.anoAtual }}
    </div>

    <div class="d-flex align-items-center">
      <strong>SGO</strong> - Sistema de Gestão de Obras

      
    </div>
  </div>

</template>

<script>
export default {
  name: 'Rodape',
  data() {
    return {
      anoAtual: new Date().getFullYear(),
      url: process.env.VUE_APP_API_URL,
      sistema: "",
    }
  }
}
</script>